import Dashboard from "@/common/components/layout/Dashboard";
import { ToastProvider } from "@/common/components/ui/toast/toast.provider";
import { useParams } from "react-router-dom";
import { RenterDashboardProvider } from "../renter-dashboard/RenterDashboard.provider";
import Toast from "@/common/components/ui/toast";
import RenterDashboardSubscription from "./RenterDashboardSubscription";


function RenterDetailsSubscription() {
  const { renterId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <RenterDashboardProvider renterId={renterId || ''}>
          <RenterDashboardSubscription />
        </RenterDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default RenterDetailsSubscription